import { createSelector } from 'reselect'
import { extractDoi } from 'lib/helpers/search'
import { resolvePlanState } from 'lib/plan'

// Authoritative view of the user's plan, derived once from the raw `ui.user` and
// `ui.organizationLicense` state so no two screens can disagree (SCI-2765).
// Consume as `useSelector(({ ui }) => selectPlanState(ui))`.
export const selectPlanState = createSelector(
  ui => ui.user,
  ui => ui.organizationLicense,
  resolvePlanState
)

export const selectMaybeDoi = createSelector(
  state => state.search.term,
  term => extractDoi(term)
)

export const selectLinkResolver = createSelector(
  state => state.linkResolver,
  state => state.hasUser,
  state => state.fetchingUser,
  state => state.user,
  (linkResolver, hasUser, fetchingUser, user) => {
    if (linkResolver) {
      return linkResolver
    }
    return null
  }
)
